import { createFileRoute, notFound } from "@tanstack/react-router";

import LandingPageView from "@/components/landing/LandingPageView";
import LandingNotFound from "@/components/landing/LandingNotFound";
import { landingPageContent } from "@/content/landing/source";
import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";

/**
 * The eleven use-case pages. The loader resolves the record rather than the
 * component, so an unknown slug is a real 404 and not a soft one.
 */
export const Route = createFileRoute("/use-cases/$slug")({
  loader: async ({ params }) => {
    const page = await landingPageContent({
      data: `/use-cases/${params.slug}`,
    });
    if (!page) {
      throw notFound();
    }
    return page;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: UseCaseRoute,
  notFoundComponent: LandingNotFound,
});

function UseCaseRoute() {
  return <LandingPageView page={Route.useLoaderData()} />;
}
